var render = function () {
  var _vm$response, _vm$response$createdA;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "answer-item"
  }, [_c('div', {
    staticClass: "answer-item__con"
  }, [_c('div', {
    staticClass: "answer-item__nickname"
  }, [_c('v-avatar', {
    attrs: {
      "size": "22"
    }
  }, [_vm._v("A")]), _vm._v(" " + _vm._s(_vm.responder.nickname) + " ")], 1), _c('div', {
    staticClass: "answer-item__content"
  }, [_vm._v(" " + _vm._s(_vm.response.content) + " "), _vm.response.files.length ? [_c('v-chip-group', _vm._l(_vm.response.files, function (file, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "value": file._id,
        "href": file.url,
        "download": ""
      }
    }, [_vm._v(" " + _vm._s(file.fileName) + " ")]);
  }), 1)] : _vm._e()], 2), _c('div', {
    staticClass: "answer-item__reply"
  }, [_c('span', {
    staticClass: "answer-item__reply-col answer-item__reply-txt"
  }, [_vm._v("답글 " + _vm._s(_vm.comments.length))]), _c('span', {
    staticClass: "answer-item__reply-col"
  }, [_c('v-btn', {
    staticClass: "answer-item__reply-txt",
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.showAddComment = !_vm.showAddComment;
      }
    }
  }, [_vm._v("답글쓰기")])], 1)]), _c('div', {
    staticClass: "answer-item__info"
  }, [_c('div', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s((_vm$response = _vm.response) === null || _vm$response === void 0 ? void 0 : (_vm$response$createdA = _vm$response.createdAt) === null || _vm$response$createdA === void 0 ? void 0 : _vm$response$createdA.toDateTime()))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isResponder,
      expression: "isResponder"
    }]
  }, [_c('span', {
    staticClass: "answer-item__info-col"
  }, [_c('response-modify', {
    attrs: {
      "response": _vm.response
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('span', {
    staticClass: "answer-item__info-col"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("삭제")])], 1)])])])]), _c('div', {
    staticClass: "answer-items"
  }, [_c('div', {
    staticClass: "answer-item"
  }, [_vm._l(_vm.comments, function (comment) {
    return _c('response-comment', {
      key: comment._id,
      attrs: {
        "comment": comment
      },
      model: {
        value: _vm.value,
        callback: function callback($$v) {
          _vm.value = $$v;
        },
        expression: "value"
      }
    });
  }), _c('response-comment-add', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAddComment,
      expression: "showAddComment"
    }],
    attrs: {
      "response": _vm.response
    },
    on: {
      "close": function close($event) {
        _vm.showAddComment = false;
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }